import { __rest } from "tslib";
import { getCurrencySymbols } from '@concur/intl-core';
import { getCurrencyFormatStr } from './formatters';
export function formatCurrencyToParts(formatters, spec) {
    var value = spec.value, options = __rest(spec, ["value"]);
    var formattedValue = value;
    if (typeof value === 'string') {
        formattedValue = parseFloat(value);
    }
    var currencyFmtStr = getCurrencyFormatStr(formatters.preferences.currencyFormat, options);
    var currencyInFront = formatters.preferences.currencyFormat.symbolLocation === 'before';
    var _a = formatters.preferences, locale = _a.locale, numberFormat = _a.numberFormat;
    var symbol = getCurrencySymbol(formatters.preferences.currencyFormat, options) || '';
    var formatter = formatters.getNumeralFormatter(locale, numberFormat);
    var formatted = formatter(formattedValue)
        .format(currencyFmtStr)
        .replace(new RegExp("\\$ \\("), "($ ")
        .replace('$', symbol);
    if (options.excludeCurrency) {
        formatted = formatted.replace(" ".concat(symbol), '').replace("".concat(symbol, " "), '');
    }
    if (symbol.length === 1) {
        formatted = formatted.replace(" ".concat(symbol), symbol).replace("".concat(symbol, " "), symbol);
    }
    formatted = formatted.trim();
    if (formatted.match('€')) {
        formatted = formatted.replace(/€(-|\d)/, '€ $1').replace(/(-|\d)€/, '$1 €');
    }
    var fullyFormatted;
    var formattedNoCurrency;
    // If user does not pass value, return null to stay consistent with other format functions
    if (typeof value === 'undefined' || value === null) {
        console.warn('formatCurrency requires "value" property defined');
        fullyFormatted = null;
        formattedNoCurrency = null;
    }
    else {
        fullyFormatted = formatted;
        formattedNoCurrency = formatted.replace(symbol, '').replace('( ', '(').replace(' )', ')').trim();
    }
    return {
        fullyFormatted: fullyFormatted,
        formattedNoCurrency: formattedNoCurrency,
        currencySymbol: symbol,
        currencyInFront: currencyInFront
    };
}
export function formatCurrency(formatters, spec) {
    if (!spec || typeof spec.value === 'undefined') {
        console.warn('formatCurrency requires "value" property defined');
        return null;
    }
    if (!spec || typeof spec.currency === 'undefined') {
        console.warn('formatCurrency requires "currency" property defined');
        return null;
    }
    return formatCurrencyToParts(formatters, spec).fullyFormatted;
}
function getCurrencySymbol(currencyPref, spec) {
    var _a, _b;
    var useCurrencySymbol = (_a = spec.useCurrencySymbol) !== null && _a !== void 0 ? _a : true;
    var symbol = (_b = getCurrencySymbols(currencyPref.baseCurrency)[spec.currency]) !== null && _b !== void 0 ? _b : spec.currency;
    // Use symbol if useCurrencySymbol is true
    if (useCurrencySymbol)
        return symbol;
    return spec.currency;
}
